import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["alignment", "justifyContent", "noPadding", "selected", "disabled", "onClick", "children", "endContent", "value", "autoHeight"];

var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB7-JOB1/src/components/Selector/Selector.js",
    _this = this;

import React, { Children } from 'react';
import { testIdProps } from '../../helpers';
import { SelectorWrapper, SelectContainer, Image, EndContent } from './style';
import SelectorBody from './SelectorBody';
import SelectorColor from './SelectorColor';

var Selector = function Selector(props) {
  var alignment = props.alignment,
      justifyContent = props.justifyContent,
      noPadding = props.noPadding,
      selected = props.selected,
      disabled = props.disabled,
      _onClick = props.onClick,
      children = props.children,
      endContent = props.endContent,
      value = props.value,
      autoHeight = props.autoHeight,
      rest = _objectWithoutProperties(props, _excluded);

  var getEndContentPropKey = function getEndContentPropKey() {
    return /*#__PURE__*/React.isValidElement(endContent) ? 'children' : 'title';
  };

  var renderEndContent = function renderEndContent() {
    if (endContent) {
      var _endContent$props, _endContentProps;

      var propKey = getEndContentPropKey();
      var endContentProps = (_endContentProps = {
        alignment: alignment,
        disabled: disabled
      }, _defineProperty(_endContentProps, propKey, endContent), _defineProperty(_endContentProps, "style", (endContent === null || endContent === void 0 ? void 0 : (_endContent$props = endContent.props) === null || _endContent$props === void 0 ? void 0 : _endContent$props.endContentStyle) || {}), _endContentProps);
      return /*#__PURE__*/React.createElement(EndContent, _extends({}, endContentProps, {
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 36,
          columnNumber: 14
        }
      }));
    }

    return endContent;
  };

  var selectorContainerAltPadding;
  var arrayChildren = Children.toArray(children);

  if (arrayChildren.some(function (child) {
    return child.type === Image && alignment === 'column' || child.type === SelectorColor;
  })) {
    selectorContainerAltPadding = true;
  }

  return /*#__PURE__*/React.createElement(SelectorWrapper, {
    selected: selected,
    autoHeight: autoHeight,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 54,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(SelectContainer, _extends({
    alignment: alignment,
    justifyContent: justifyContent,
    selected: selected,
    disabled: disabled,
    onClick: function onClick(event) {
      return _onClick(value, event);
    },
    noPadding: noPadding,
    altPadding: selectorContainerAltPadding
  }, testIdProps(rest), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 55,
      columnNumber: 7
    }
  }), children, renderEndContent()));
};

Selector.defaultProps = {
  alignment: 'row',
  selected: false,
  disabled: false,
  onClick: function onClick() {},
  justifyContent: 'space-between',
  noPadding: false,
  autoHeight: false
};
Selector.Body = SelectorBody;
Selector.Image = Image;
Selector.Color = SelectorColor;
export default Selector;